/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jun 21 2023
 **/

import styled from "@emotion/styled";

import { Menu } from "@/frameworks/designStuff/components";

export const SubMenu = styled(Menu)`
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	padding: 8px;
	width: 100%;
	border-radius: 0;
	box-sizing: border-box;
	box-shadow: none;
`;

export const MenuItem = styled(Menu.Item)`
	width: 100%;
	border-radius: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondary_80_8};
	}
	.buttonText {
		width: 100%;
		text-align: left;
	}
	button {
		&:hover {
			background: none;
		}
	}
`;
